<script>
	import Alert from './componentes/Alert.svelte';
	import ModuloPago from './componentes/ModuloPago.svelte';
	import { iduser, sucursal, urlapp, miPermiso } from './stores/store.js';
	import ModalPago from './componentes/ModalPago.svelte';
	import Modal from './components/Modal.svelte';
	import Carrito from './components/Carrito.svelte';
	import Totales from './components/Totales.svelte';
	import Datoscliente from './componentes/Datoscliente.svelte';
	import AnimationContainer from './components/AnimationContainer.svelte';
    import { moneda, object2array, postData } from "./scripts";
    import { push } from "svelte-spa-router";
    //import {breakpoint, platform} from './MediaQuery.svelte'
    import { login, prefix, urlapi, viewsXpages } from './stores/store';
    import moment from 'moment'
    import { breakpoint } from './componentes/MediaQuery.svelte';
    import Input from './componentes/Forms/Input.svelte';

    let carritoObj=false;

    /* PERMISOS */
    let viewPage=false;

    let existecia_ignorar=false;
    let aplicar_descuento=false;

    if($login===false)
    {
        push('/login')
    } else if($miPermiso.facturacion.insert===false) {
        push('/sinpermiso')
    } else {
        postData($urlapi, [{ 'cmd':'globales_getOptions' }])
            .then(data => {
                existecia_ignorar=data[0].result.existecia_ignorar;
                aplicar_descuento=data[0].result.aplicar_descuento;
                viewPage=true;
        });
    }

    /* FIN PERMISOS */

    let cliente={activo:true,nit:'',nombre:'',direccion:'',tipo_cliente:'M'};
    let carrito=[]
    
    // COMENTAR DESPUES
    //cliente={activo:false,nit:'65856686',nombre:'GRUPO WEB PUBLICIDAD, S.A.',direccion:'GUATEMALA, CIUDAD'};
    
    /*let carrito=[
        { codigo:'10000001',descripcion:'PIEZA DE HOMBRE', cantidad:2,precio:10.30,descuento:0,total:20.60,selected:false,lock:true,encontrado:true},
    ]*/   
    
    //let cliente={activo:false,nit:'36600792',nombre:'CHRISTIAN LAPUENTE',direccion:'GUATEMALA, CIUDAD',tipo_cliente:'M'};

/*    carrito=[
        { codigo:'10000001',descripcion:'PIEZA DE HOMBRE', cantidad:2,precio:10.30,descuento:20.1,total:20.60,selected:false,lock:true,encontrado:true},
        { codigo:'30000001',descripcion:'PIEZA DE NIÑOS', cantidad:2,precio:27.43,descuento:0,total:54.86,selected:false,lock:true,encontrado:true},
        { codigo:'10000001',descripcion:'PIEZA DE HOMBRE', cantidad:2,precio:10.30,descuento:0,total:0,selected:false,lock:true,encontrado:true},
        { codigo:'20000001',descripcion:'ACCESORIO DAMA', cantidad:2,precio:60.00,descuento:0,total:0,selected:false,lock:true,encontrado:true},
        { codigo:'30000001',descripcion:'ACCESORIO DE NIÑO', cantidad:6,precio:50.00,descuento:0,total:0,selected:false,lock:true,encontrado:true},
    ]*/
    
    /*let carrito=[
        { codigo:'10000001',descripcion:'PIEZA DE HOMBRE', cantidad:1,precio:10.30,descuento:0,total:30.90,selected:false,lock:true,encontrado:true},
        { codigo:'',descripcion:'PRODUCTO NO ASIGNADO', cantidad:0,precio:0,descuento:0,total:0,selected:false,lock:false,encontrado:false},
    ]*/

    let factura={total:0, descuento:0, cantidad:0, noverificarexistencias:false, carrito:carrito, pagado:false,formaPago:false,efectivo:'',efectivo_real:0,tarjeta:''};
    let firmarModal=false;

    let firma={fecha: '',serie: '',numero: '',autorizacion: '',cantidad: 0,total: 0}

    let firma_disponible=false;

    $: if(cliente)
    {
        let countProductos = factura.carrito.filter(function(item){
                if (item.encontrado === true) {
                    return true;
                } else {
                    return false;
                }
            }).length;

        if(cliente.activo===false && countProductos>0) {
            firma_disponible=true;    
        } else {
            firma_disponible=false;
        }
    }

    let cancelarFactura=function () {
        setTimeout(() => {
            cliente={activo:true,nit:'',nombre:'',direccion:'', pagado:false,formaPago:false,efectivo:'',tarjeta:'',autorizacion_tarjeta:''};
            factura={total:0, cantidad:0, noverificarexistencias:false, carrito:[], pagado:false,formaPago:false,efectivo:'',efectivo_real:0,tarjeta:''};
            firmarModal=false;
            errores_existencia=false;
            errores_facturas=false;
            PagarButton=true;
            //resetFormaPago();
        }, 300);
    }

    

    let firmar=function() { firmarModal=true }

    function uuidv4() {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        ).toUpperCase();
    }

    let PagarButton=true;
    let ModalPagoObject=null;
    let errores_existencia=false;
    let errores_fel=false;
    let errores_facturas=false;

    let procedersinexistencias=function() {
        errores_existencia=false;
        factura.noverificarexistencias=true;
        pagar();
    }

    let pagar=function() {
        errores_fel=false;
        errores_existencia=false;

        if(cliente.nit.trim()=='')
        {
            errores_facturas='Ingrese número de NIT';
            setTimeout(() => { PagarButton=true; }, 1000);
        } else if(factura.carrito.length==0) {
            errores_facturas='Ingrese producto(s)';
            setTimeout(() => { PagarButton=true; }, 1000);
        } else {
            factura.pagado=true;

            let seleccionados = factura.carrito.filter(function(item){
                if (item.encontrado === false) {
                    return false;
                } else {
                    return true;
                }
            });    
            factura.carrito=[...seleccionados]

            postData($urlapi, [{'cmd':'facturas_insert','noverificarexistencias':factura.noverificarexistencias,'detalle':factura,'cliente':cliente,'user':{'iduser':$iduser,'sucursal':$sucursal}}])
            .then(data => {
                if(data[0].result===false)
                {
                    factura.pagado=false;
                    if(data[0].error_tipo=='existencias') {
                        errores_existencia=object2array( data[0].errores );
                    } else {
                        errores_fel=object2array( data[0].errores );
                    }
                    setTimeout(() => { PagarButton=true; }, 1000);
                } else {
                    errores_fel=false;
                    errores_existencia=false;
                    factura.pagado=false;
                    cancelarFactura()
                    window.open($urlapp+'print/factura.php?id='+data[0].id);
                    //console.log($urlapp+'print/factura.php?id='+data[0].id);
                }
            });
        }
    }
    let actualizarTotales=function() {
        carritoObj.calcular();
        carritoObj.calcular_descuento();
    }

</script>

{#if viewPage===true}
<!-- <Navbar /> -->
<AnimationContainer container={false}>

   {#if firmarModal}
        <ModuloPago bind:factura={factura} on:update={actualizarTotales} on:close={()=>firmarModal=false} on:pagar={pagar} bind:PagarButton={PagarButton}/>
   {/if}

   

    <div class="container-fluid bg-dark pt-1 pb-1">
        <div class='row'>
            <div class="col-12">
                
                <button disabled={!firma_disponible}
                    class:btn-lg={$breakpoint === 'xxl'}
                    class:btn-md={$breakpoint !== 'xxl'}
                    on:click={firmar} type="button" class='btn btn-success me-3 '>
                    <i class="bi bi-receipt-cutoff me-1"></i>GUARDAR</button>

                <div class="float-end"
                    class:mt-1={$breakpoint !== 'xxl'}
                >
                    <Modal textButton='CANCELAR' functionSi={cancelarFactura}

                    classButton='btn-danger {($breakpoint === 'xxl')?"btn-lg":"btn-sm"}' iconButton='bi-x-square' title='ADVERTENCIA'>
                        Esta seguro que desea <strong>CANCELAR</strong>?<br/>
                        Se perderán los datos de la factura
                    </Modal>                    
                    <!-- <button type="button" on:click={cancelarFactura} class='btn btn-danger btn-sm me-1'><i class="bi bi-x-square me-1"></i>CANCELAR</button> -->
                    <button type="button"
                        class:btn-lg={$breakpoint === 'xxl'}
                        class:btn-sm={$breakpoint !== 'xxl'}
                        on:click={()=>push('/facturas')} class='btn btn-warning'><i class="bi bi-box-arrow-left me-1"></i>SALIR</button>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <div class='row'>
            
            <div class="col-8">
                <Datoscliente bind:cliente={cliente} bind:factura={factura} on:validate={()=>carritoObj.buscar_producto_nuevo()}/>
            </div>
            <div class="col-4">
                <Totales bind:factura={factura}/>
            </div>
        </div>
        {#if errores_existencia!==false}
            <div class='mb-2'>
                <Alert parpadea disableMarginBottom valign='top' lheight='2'>
                    {#each errores_existencia as item}
                        <p class='mb-1'>
                            <strong>Error de existencia:</strong> [{item.codigo}] {item.nombre}
                            <span class="badge bg-warning text-dark">Existencia: {item.cantidad_existencia}</span>
                            <span class="badge bg-danger">Solicitado: {item.cantidad_solicitada}</span>
                        </p>
                    {/each}
                    {#if existecia_ignorar===true}
                        <button on:click={procedersinexistencias} class='btn btn-success clearfix mt-2 mb-2'><i class="bi bi-receipt me-1"></i>Proceder sin existencias</button>
                    {/if}
                </Alert>
            </div>
        {/if}
        {#if errores_fel!==false}
            <div class='mb-2'>
                <Alert parpadea disableMarginBottom valign='top' lheight='2'>
                    {#each errores_fel as item}
                        <p class='mb-1'>
                            <strong>Error FEL:</strong> {item}
                            <!-- <span class="badge bg-warning text-dark">Existencia: {item.cantidad_existencia}</span>
                            <span class="badge bg-danger">Solicitado: {item.cantidad_solicitada}</span> -->
                        </p>
                    {/each}
                </Alert>
            </div>
        {/if}
        

        {#if errores_facturas!==false}
            <div class='mb-2'>
                <Alert parpadea disableMarginBottom valign='top' lheight='2'>
                    {errores_facturas}
                </Alert>
            </div>
        {/if}        
        
        
        <div>
            <Carrito bind:factura={factura} bind:cliente={cliente} bind:this={carritoObj} bind:aplicar_descuento={aplicar_descuento}/>
        </div>
    </div>

</AnimationContainer>    
{/if}